import { useQuery } from '@tanstack/react-query';

import { getOfferingDocumentRaw } from '@arrived/api_v2';
import { OfferingDocumentId } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { offeringDocumentRawKeyFn } from './offerings.keys';

export function useGetOfferingDocumentRawQuery(
  offeringDocumentId: OfferingDocumentId,
  options?: UseQueryOptions<Blob>
) {
  return useQuery(
    offeringDocumentRawKeyFn(offeringDocumentId),
    async () => getOfferingDocumentRaw(offeringDocumentId),
    {
      ...options,
      staleTime: options?.staleTime ?? MAX_STALE_TIME,
    }
  );
}
